import {
  AuditLogListQuerySchema,
  DashboardResumenSchema,
  ReporteFinancieroSchema,
  ReporteOperacionalQuerySchema,
  ReporteOperacionalSchema,
  ReportePeriodQuerySchema,
  ReporteRrhhSchema,
} from '@visep/shared-types/reportes';
import type {
  AuditLogListQuery,
  DashboardResumen,
  ReporteFinanciero,
  ReporteOperacional,
  ReporteOperacionalQuery,
  ReportePeriodQuery,
  ReporteRrhh,
} from '@visep/shared-types/reportes';
import { AuditLogEntrySchema } from '@visep/shared-types/audit';
import type { AuditLogEntry } from '@visep/shared-types/audit';
import type { Helpers, ListResult } from './internal.js';
import { listResultSchema, toQuery } from './internal.js';

export function createReportesResource({ request }: Helpers) {
  return {
    async financiero(query?: ReportePeriodQuery): Promise<ReporteFinanciero> {
      const parsed = ReportePeriodQuerySchema.parse(query ?? {});
      return ReporteFinancieroSchema.parse(await request('GET', `/api/reportes/financiero${toQuery(parsed)}`));
    },
    async rrhh(query?: ReportePeriodQuery): Promise<ReporteRrhh> {
      const parsed = ReportePeriodQuerySchema.parse(query ?? {});
      return ReporteRrhhSchema.parse(await request('GET', `/api/reportes/rrhh${toQuery(parsed)}`));
    },
    async operacional(query?: ReporteOperacionalQuery): Promise<ReporteOperacional> {
      const parsed = ReporteOperacionalQuerySchema.parse(query ?? {});
      return ReporteOperacionalSchema.parse(await request('GET', `/api/reportes/operacional${toQuery(parsed)}`));
    },
    async dashboard(): Promise<DashboardResumen> {
      return DashboardResumenSchema.parse(await request('GET', '/api/reportes/dashboard'));
    },
    async auditoria(query?: AuditLogListQuery): Promise<ListResult<AuditLogEntry>> {
      const parsed = AuditLogListQuerySchema.parse(query ?? {});
      return listResultSchema(AuditLogEntrySchema).parse(await request('GET', `/api/auditoria${toQuery(parsed)}`));
    },
  };
}
